import * as TypeGraphQL from "type-graphql";
export var OptionPositionStatus;
(function (OptionPositionStatus) {
    OptionPositionStatus["OPEN"] = "OPEN";
    OptionPositionStatus["CLOSED"] = "CLOSED";
    OptionPositionStatus["EXPIRED"] = "EXPIRED";
    OptionPositionStatus["ASSIGNED"] = "ASSIGNED";
})(OptionPositionStatus || (OptionPositionStatus = {}));
TypeGraphQL.registerEnumType(OptionPositionStatus, {
    name: "OptionPositionStatus",
    description: undefined,
});
//# sourceMappingURL=OptionPositionStatus.js.map